import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { postStreamItem } from '../../../api/items';

import { mergeItemWithUserData } from '../../../utils/items';
import { generateChannelCIDKey } from '../../../utils/generateChannelCIDKey';

import { POST_STREAM_ITEM_METHODS } from '../constants/postStreamItemMethods';

export const createThread = createAsyncThunk(
  'items/createThread',
  async ({ path, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [itemResponse, itemUserDataResponse] = await postStreamItem(
        {
          path,
          params: {
            method: POST_STREAM_ITEM_METHODS.createThread,
            channelPath: generateChannelCIDKey({
              orgId: params.orgIdC,
              streamId: params.streamIdC,
              channelId: params.channelIdC,
            }),
          },
        },
        {
          cancelToken: source.token,
        },
      );

      return mergeItemWithUserData(itemResponse, itemUserDataResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);
